import ProductTransformer from './ProductTransformer';

export default class ProductAdministrationSelectionTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteAdministrationSelection') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'providerName',
      'descriptionAdministrationSelection',
      'fixedLineNumberLabel',
      'fixedLineNumberText',
      'hintDescriptionAdministrationSelection',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
